import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InviteFriendModalModule } from 'AccountsApp/ts/features/invite-friend-modal/invite-friend-modal.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { RefreshRequiredModalModule } from 'Angular/features/components/modals/refresh-required-modal/refresh-required-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { StringPipesModule } from 'Angular/features/pipes/string/string-pipes.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import * as i0 from "@angular/core";
/**
 * The non standalone internals of the top bar nav (menu lists, user menu, impersonation).
 * Kept in their own module so the standalone TopBarNavComponent can import them without a
 * circular file dependency on NavigationModule (which re-exports `TopBarNavComponent`).
 */
export class NavigationInternalsModule {
}
NavigationInternalsModule.ɵfac = function NavigationInternalsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NavigationInternalsModule)(); };
NavigationInternalsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NavigationInternalsModule });
NavigationInternalsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule,
        CommonModule,
        FormsModule,
        IconModule,
        InviteFriendModalModule,
        RefreshRequiredModalModule,
        StringPipesModule,
        TooltipModule,
        LoadingSymbolModule] });
